import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from '../../COLORS'

export const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 36,
    fontWeight: 800,
    color: COLORS.BLUE,
    [theme.breakpoints.down('md')]: {
      fontSize: 28
    },
    marginBottom: 50
  },
  titleInherit: {
    margin: 0,
    fontSize: 'inherit',
    fontWeight: 900
  },
  subtitle: {
    color: COLORS.BLUE,
    fontSize: 28,
    fontWeight: 800,
    borderBottom: '4px solid #9b9b9b',
    marginBottom: 25,
    paddingBottom: 10,
  },
  box: {
    marginBottom: 25,
  },
  minTitle: {
    color: COLORS.BLUE,
    fontSize: 18,
    fontWeight: 800,
    marginBottom: 10,
    display: 'inline-block'
  },
  text: {
    fontSize: 14,
    marginBottom: 25
  },

}))

